/**
 * /release-feed.json — the public release feed (KPR-791): a static file the
 * web build writes from the deploy ledgers' public lines
 * (scripts/build-release-feed.mjs), served by the web host next to the app.
 * Not the API, so not src/api/client.js: it is the same file for everyone,
 * fetched with no credentials, signed in or out.
 *
 * Where the file does not exist (the dev server, a build without the
 * postbuild step) the host answers its app shell with a 200, so anything that
 * is not JSON is a failure here. Read the result with normalizeReleaseFeed
 * (utils/releaseFeed.js).
 */
export const RELEASE_FEED_PATH = '/release-feed.json';

export async function getReleaseFeed() {
	const response = await fetch(RELEASE_FEED_PATH, { credentials: 'omit', cache: 'no-cache' });
	const type = (response.headers && response.headers.get('content-type')) || '';
	if (!response.ok || !type.includes('json')) throw new Error('The release feed is not published here.');
	return response.json();
}

export default getReleaseFeed;
